import { render, staticRenderFns } from "./presentation.vue?vue&type=template&id=79b5a7a3&scoped=true&"
import script from "./presentation.vue?vue&type=script&lang=js&"
export * from "./presentation.vue?vue&type=script&lang=js&"
import style0 from "./presentation.vue?vue&type=style&index=0&id=79b5a7a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b5a7a3",
  null
  
)

export default component.exports